import React from 'react';
import { styled } from '@mui/material';
import { CircularProgress } from '@mui/material';
import Typography from '../../Typography';
var Root = styled('div')(function (_a) {
    var theme = _a.theme, loading = _a.loading;
    var height = 54;
    var s = loading ? '0.07s' : '0.15s';
    return {
        zIndex: 2,
        transition: "top ".concat(s, " ease-in-out"),
        paddingLeft: 18,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        top: loading ? 0 : "-".concat(height, "px"),
        left: 0,
        backgroundColor: theme.palette.primary.light,
        height: height
    };
});
var Text = styled(Typography)(function (_a) {
    var theme = _a.theme;
    return ({
        color: theme.palette.primary.main,
        marginLeft: 16,
        fontSize: 14
    });
});
var TableLoading = function (_a) {
    var loading = _a.loading, nameText = _a.nameText;
    var getText = function () {
        var defaultText = '正在载入';
        if (nameText) {
            if (typeof nameText === 'string')
                return "".concat(defaultText).concat(nameText);
            if (typeof nameText === 'function')
                return nameText('loading');
        }
        return defaultText;
    };
    return (React.createElement(Root, { loading: loading },
        React.createElement(CircularProgress, { size: 16 }),
        React.createElement(Text, null, getText())));
};
export default TableLoading;
